import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, SlidersHorizontal, Building2 } from 'lucide-react';
import { apartmentService } from '../services/api';
import ApartmentCard from '../components/ApartmentCard';
import { ApartmentSummary } from '../types';

const ApartmentListPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [apartments, setApartments] = useState<ApartmentSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ ville: searchParams.get('ville') || '', capacite: '', prixMax: '' });

  useEffect(() => {
    const fetchApartments = async () => {
      setLoading(true);
      try {
        const params: any = { per_page: 20 };
        if (filters.ville) params.ville = filters.ville;
        if (filters.capacite) params.capacite_min = parseInt(filters.capacite);
        if (filters.prixMax) params.prix_max = parseInt(filters.prixMax);
        const res = await apartmentService.getAll(params);
        setApartments(res.data.apartments || []);
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    fetchApartments();
  }, [filters]);

  return (
    <div className="section">
      <div className="container-app">
        <h1 className="text-3xl font-heading font-bold text-neutral-900 mb-8">Nos appartements</h1>
        
        {/* Filtres */}
        <div className="card p-4 mb-8">
          <div className="flex flex-wrap gap-4">
            <div className="flex-1 min-w-[200px]">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400" />
                <input type="text" placeholder="Ville" value={filters.ville} onChange={(e) => setFilters({...filters, ville: e.target.value})} className="input pl-10" />
              </div>
            </div>
            <select value={filters.capacite} onChange={(e) => setFilters({...filters, capacite: e.target.value})} className="input w-auto">
              <option value="">Capacité</option>
              <option value="1">1+ personne</option>
              <option value="2">2+ personnes</option>
              <option value="4">4+ personnes</option>
              <option value="6">6+ personnes</option>
            </select>
            <select value={filters.prixMax} onChange={(e) => setFilters({...filters, prixMax: e.target.value})} className="input w-auto">
              <option value="">Prix max</option>
              <option value="25000">25 000 FCFA</option>
              <option value="50000">50 000 FCFA</option>
              <option value="100000">100 000 FCFA</option>
            </select>
          </div>
        </div>

        {/* Liste */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (<div key={i} className="card animate-pulse"><div className="aspect-[4/3] bg-neutral-200"></div><div className="p-4 space-y-3"><div className="h-5 bg-neutral-200 rounded w-3/4"></div><div className="h-4 bg-neutral-200 rounded w-1/2"></div></div></div>))}
          </div>
        ) : apartments.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {apartments.map((apt) => (<ApartmentCard key={apt.id} apartment={apt} />))}
          </div>
        ) : (
          <div className="text-center py-16"><Building2 className="w-16 h-16 text-neutral-300 mx-auto mb-4" /><p className="text-neutral-500">Aucun appartement trouvé</p></div>
        )}
      </div>
    </div>
  );
};
export default ApartmentListPage;
